/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  let blockImageUpdate = false;

  document.addEventListener('DOMContentLoaded', function () {
    const selectors = document.querySelectorAll('[data-single-option-selector]');

    selectors.forEach(function (selector) {
      const optionIndex = selector.getAttribute('data-index');

      selector.addEventListener('change', function (e) {
        if (optionIndex === 'option2') { // Size option
          blockImageUpdate = true;
          e.stopImmediatePropagation();
          setTimeout(() => blockImageUpdate = false, 100);
        }
      });
    });

    document.addEventListener('theme:media:select', function (e) {
      if (blockImageUpdate) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);
  });
})();
